// Modules
import { Action, createReducer, on } from '@ngrx/store';

// Interfaces
import { INavigationItem } from '@shared/interfaces';

// Actions
import * as GeneralActions from '@store/actions/general.actions';

export interface GeneralState {
  currentPage: INavigationItem;
}

export const initialGeneralState: GeneralState = {
  currentPage: null,
};

const generalReducer = createReducer(
  initialGeneralState,
  on(GeneralActions.setCurrentPage, (state, action) => ({
    ...state,
    currentPage: action.payload,
  }))
);

export function reducer(
  state: GeneralState | undefined,
  action: Action
): GeneralState {
  return generalReducer(state, action);
}
